export default "__VITE_ASSET__ad21b384__"